import { motion } from 'framer-motion';

import GoogleRating from '../../components/GoogleRating';
import Testimonial from '../../components/Testimonial';
import sheridanImage from '../../assets/sheridan_testimonial.png';
import customerImage from '../../assets/avatar.png';

import CustomerText from '../../components/CustomerText';
import BusinessRequest from '../../components/BusinessRequest';
import BusinessText from '../../components/BusinessText';
import {
  businessContent,
  customerTextContent,
  testimonialAttribution,
  testimonialText,
  googleIcon,
} from './content';
import { getFadeUpAnimationProps, getPopAnimationProps } from '../../utils';
import BoxWrapper from '../../components/BoxWrapper';

const Reviews = () => {
  return (
    <>
      <BoxWrapper marginTop="40px">
        <motion.div {...getPopAnimationProps(1, 0.75)}>
          <BusinessText content={businessContent} />
        </motion.div>

        <motion.div {...getPopAnimationProps(1.5, 0.75)}>
          <BusinessRequest icon={googleIcon} content="Leave us a review!" />
        </motion.div>
      </BoxWrapper>

      <BoxWrapper>
        <motion.div {...getPopAnimationProps(2.5, 0.75)}>
          <CustomerText image={customerImage} content={customerTextContent} />
        </motion.div>
      </BoxWrapper>
      <BoxWrapper>
        <motion.div {...getPopAnimationProps(3, 0.75)}>
          <GoogleRating />
        </motion.div>
      </BoxWrapper>
      <BoxWrapper marginTop="40px">
        <motion.div {...getFadeUpAnimationProps(3.5, 0.3)}>
          <Testimonial
            image={sheridanImage}
            text={testimonialText}
            attribution={testimonialAttribution}
          />
        </motion.div>
      </BoxWrapper>
    </>
  );
};

export default Reviews;
